module.exports = "/_next/static/images/eaef395fbfa870824b052b54e2ca08ab-hero-mobile.jpg";